module.exports = __webpack_public_path__ + "img/bing-ads.c7239abc.png";